import { Heading } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import { LanguageSelector } from '../../components/LanguageSelector/LanguageSelector'
import { useStyles } from './LanguageSelect.styles'

export const LanguageSelect = () => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <section className={classes.section}>
      <Heading headingLevel="1" headingLevelStyle="3">
        {t('Interface language')}
      </Heading>

      <div className={classes.select}>
        <LanguageSelector />
      </div>
    </section>
  )
}
